import React, { Component } from "react";
import Select from "react-select";
import { SkyLightStateless } from 'react-skylight';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import _ from 'lodash';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";
import { Toolbar, Data } from "react-data-grid-addons";
import ReactDataGrid from "react-data-grid";
import axios from 'axios';
import {
  ROOT_URL, //https://abc-scm.truckxi.com/api/
} from '../../../../actions/root_url';
import { InputField } from '../../inputField';

const monitorOrderAPI = (data, success) => {
  axios({
    method: 'POST',
    url: `${ROOT_URL}v1/sale/monitor_order/ `,
    data,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
  }).then(res => {
    success();
  }).catch(err => {
    if (err.data) {
      alert(JSON.stringify(err.data))
    } else {
      alert(JSON.stringify(err));
    }
  });
}

const modalStyle = {
  width: '500px',
  height: '260px',
  marginLeft: '-10%',
}

const propTypes = {
}

const defaultProps = {
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonToolbar: {
    display: 'flex',
    justifyContent: 'space-evenly',
    width: '100%',
    marginTop: '40px',
  }
}

class BarcodeVerifyFailed extends Component {
  // state = {
  //   note: '',
  // }

  // handleConfirmClick = () => {
  //   const data = {
  //     SalesOrderId: this.props.monitorRow.SalesOrder_id,
  //     Notation: this.state.note,
  //   }
  //   const success = () => {
  //     this.props.handleMonitorOrderSuccess();
  //   }
  //   monitorOrderAPI(data, success);
  // }

  render() {
    return (
      <form style={styles.container}>
        {/* <h4>Location Change</h4> */}
        <div style={{ width: '100%', textAlign: 'center', height: '130px' }}>
          {this.props.barcodeVerifyFailedMsg}
        </div>
        <div style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-around', marginTop: '10px' }}>
          <Button
            bsStyle="primary"
            className="print-btn"
            type="button"
            onClick={() => {
              this.props.onClose()
            }}
          >
            <Translate value="cancel" />
          </Button>
          <Button
            bsStyle="primary"
            className="print-btn"
            type="button"
            onClick={() => {
              this.props.onConfirm()
            }}
          >
            <Translate value="continue" />
          </Button>
        </div>
      </form>
    )
  }
}

const BarcodeVerifyFailedModal = ({ isVisible, onClose, onConfirm, barcodeVerifyFailedMsg }) => (
  <SkyLightStateless
    title={'Barcode Verify'}
    onCloseClicked={onClose}
    dialogStyles={modalStyle}
    isVisible={isVisible}
  >
    <BarcodeVerifyFailed barcodeVerifyFailedMsg={barcodeVerifyFailedMsg} onClose={onClose} onConfirm={onConfirm} />
  </SkyLightStateless>
)

BarcodeVerifyFailedModal.propTypes = propTypes
BarcodeVerifyFailedModal.defaultProps = defaultProps

export default BarcodeVerifyFailedModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/generalManagement/BarcodeVerifyFailedModal.jsx